export default {
  namespaced: true,
  state: {
    isOpen: false,
    component: null,
    props: {},
    width: null,
    reloadKey: 0
  },
  mutations: {
    setOpen(state, isOpen) {
      state.isOpen = isOpen
    },
    setComponent(state, component) {
      state.component = component
    },
    setProps(state, props) {
      state.props = props
    },
    setWidth(state, width) {
      state.width = width
    },
    incrementReloadKey(state) {
      state.reloadKey++
    },
    reset(state) {
      state.isOpen = false
      state.component = null
      state.props = {}
      state.width = null
    }
  },
  actions: {
    open({ commit, dispatch }, { component, props = {}, width = null }) {
      commit('setComponent', component)
      commit('setProps', props)
      commit('setWidth', width)
      commit('setOpen', true)
      dispatch('reload')
    },
    openQuickview({ dispatch }, props = {}) {
      dispatch('open', {
        component: 'quick-view',
        props
      })
    },
    close({ commit }) {
      commit('reset')
    },
    reload({ commit }) {
      commit('incrementReloadKey')
    }
  }
}